module.exports = __webpack_public_path__ + "assets/img/right-label-en.f91896e6.png";